import { render, staticRenderFns } from "./autoSmsModal.vue?vue&type=template&id=0be52ed3&"
import script from "./autoSmsModal.vue?vue&type=script&lang=js&"
export * from "./autoSmsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports